import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.SET_USER,
    user
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/setUser.js